export default "__VITE_ASSET__CeRBQt$O__"